export default "__VITE_ASSET__ffe83daa__"